define('lq/events/actions/import',[
    'lq/events/actions/eventAction',
    'lq/uploader'
], function (EventAction, Uploader) {
    'use strict';

    var Import = function (eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.data = eventData.excelImport;
        return this;
    };

    EventAction.extend(Import, EventAction);

    Import.typeName = 'Import';

    Import.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Import.prototype.execute = function (continuation) {
        var self = this;
        var filters = this.eventData.type === 'Xlsx' ? ".xlsm,.xlsx" : ".csv";
        new Uploader(this.piping)
            .toTenantUrl('Import/' + self.eventData.type)
            .withFileFilter(filters)
            .withParameters({
                actionId: this.piping.actionId,
                importMorphId: this.eventData.command,
                localParameters: JSON.stringify(this.piping.parameters.locals.getAll()),
                globalParameters: JSON.stringify(this.piping.parameters.globals.getAll())
            })
            .onFileUploaded(function(uploadResponse) {
                if (uploadResponse.isDirty) {
                    self.handleExecutionTrailDirty(continuation);
                } else {
                    if (uploadResponse && uploadResponse.success) {
                        _.each(uploadResponse.globalParameters, function (val, key) {
                            self.piping.parameters.globals.setValue(key, val);
                        });
                        _.each(uploadResponse.localParameters, function (val, key) {
                            self.piping.parameters.locals.setValue(key, val);
                        });
                        if (self.eventData.filenameParameter && uploadResponse.filename)
                            self.piping.parameters.locals.setValue(self.eventData.filenameParameter, uploadResponse.filename);
                    } else if (uploadResponse.report) {
                        var reportMessages = self.convertReportToErrorMessage(uploadResponse.report);
                        if (!self.piping.errorHandler.handleError(reportMessages))
                            alert(reportMessages);
                    } else {
                        var errorMessage = uploadResponse && uploadResponse.message
                            ? uploadResponse.message
                            : 'The file could not be imported.';
                        if (!self.piping.errorHandler.handleError(errorMessage))
                            alert(errorMessage);
                    }
                }
            })
            .onUploadFinished(function () {
                self.piping.busyIndicator.hide();
                continuation();
            })
            .onFileUploadCancel(function () {
                self.triggerEventIfEnabled('fileUploadCancelled');
                continuation({ break: true });
            })
            .onMaxFileSizeExceeded(function (filename, maxFileSizeInKb) {
                if (self.eventIsEnabled('maxFileSizeExceeded'))
                    self.triggerEvent('maxFileSizeExceeded');
                else
                    alert(filename + ' is too large, maximum file size is ' + maxFileSizeInKb + 'KB');
                continuation({ break: true });
            })
            .onInvalidFileExtension(function (filename) {
                if (self.eventIsEnabled('invalidFileType'))
                    self.triggerEvent('invalidFileType');
                else
                    alert('File upload rejected: "' + filename + '" is not a permitted file.');
                continuation({ break: true });
            })
            .uploadSingleFile();
    };

    Import.prototype.convertReportToErrorMessage = function (reports) {
        if (reports.length === 1) {
            var errors = this.mergeErrorMessages(reports[0]);
            var message = 'One or more errors occurred during the import. The affected lines were not imported.';
            return message + '\n' + errors;
        }

        var self = this;
        var allMessages = _.map(reports, function (report) {
            var errors = self.mergeErrorMessages(report);
            var message = 'One or more errors occurred during the import of "' + report.name + '". The affected lines were not imported.';
            return message + '\n' + errors;
        });
        return allMessages.join('\n');
    };

    Import.prototype.mergeErrorMessages = function(report) {
        var errors =  _.map(report.errors, function (error) {
            var rowNumber = error.row + 1; // row number is zero-based on the server
            var columnNumberText = error.column != null ? ' Column ' + error.column : '';
            return 'Row ' + rowNumber + columnNumberText + ': ' + error.message;
        });
        return errors.join('\n');
    };

    return Import;
});
